// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__5qmih"};